import { createSelector } from '@reduxjs/toolkit';

import { recipesAdapter } from '../../common/store/adapters/recipesAdapter';
import type { RootState } from '../../common/store/structureDefinitions/cartState';

const recipeSelectors = recipesAdapter.getSelectors((state: RootState) => state.cart.recipes);
const selectNonEmptyRecipes = createSelector(recipeSelectors.selectAll, (cartRecipes) =>
    cartRecipes.filter((x) => !!x.productsMap?.length),
);

const selectNonEmptyRecipeIds = createSelector(selectNonEmptyRecipes, (cartRecipes) =>
    cartRecipes.map((item) => item.code),
);
const selectNonEmptyRecipebyId = createSelector(
    selectNonEmptyRecipes,
    (_: RootState, recipeId: string) => recipeId,
    (cartRecipes, recipeId) => cartRecipes.find((item) => item.code === recipeId),
);

const hasFoodboxInCart = createSelector(recipeSelectors.selectAll, (cartRecipes) =>
    cartRecipes.some((r) => r.group === 'foodbox'),
);

const selectRecipesCalculationType = createSelector(recipeSelectors.selectAll, (cartRecipes) => {
    const recipes = cartRecipes.filter((r) => r.type === 'recipe');
    if (recipes.length === 0) {
        return null;
    }

    // we can always take first recipe as all recipes in cart should have same calculation type and prioritization type
    return {
        calculationType: recipes[0].calculationType,
        prioritizationType: recipes[0].prioritizationType,
    };
});

const cartRecipeSelectors = {
    all: recipeSelectors,
    nonEmpty: {
        selectAll: selectNonEmptyRecipes,
        selectIds: selectNonEmptyRecipeIds,
        selectById: selectNonEmptyRecipebyId,
    },
    hasFoodboxInCart,
    selectRecipesCalculationType,
};

export default cartRecipeSelectors;
